<template>
  <div class="dashboard-settings">
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  margin-top: 0;
  font-size: 2rem;
}
</style>

<script>
import CARDS from './cards';
import Overview from './Overview';
export default {
  // Sub-route configuration
  children: [
    {
      path: '',
      component: Overview,
    }].concat(
      CARDS.map(card => ({
        path: card.key,
        component: card.editComponent,
      }))
    )
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/Settings.vue